<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="machine.machine_id && machine.machine_id > 0" @invoke-method="refresh(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="machine.machine_id && machine.machine_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('machines.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in machine_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != machine.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('machines.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_machine.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'machines' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-container grid-list-xl>
                <v-layout row :wrap="$bp.smallScreen">
                    <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                        <v-layout row wrap>
                            <v-flex xs8 py-0>
                                <bc-tooltip right v-if="hasPerm('machines.update')">
                                    <template slot="activator">
                                        <v-btn
                                            style="text-transform: none"
                                            class="pl-1"
                                            round
                                            selected
                                            :color="machine.status_class"
                                            text-color="white"
                                            @mouseup.left="changeStatus({ option_id: machine.status_id == '175' ? '176' : '175' })"
                                        >
                                            <v-icon color="white" class="mr-2" v-model="machine.status">{{
                                                status_loader ? "fas fa-circle-notch fa-spin" : machine.status_id == "175" ? "check_circle" : "cancel"
                                            }}</v-icon>
                                            <span class="white--text">{{
                                                status_loader ? $t("lang.loading") : machine.status_id == "175" ? "Operational" : "Out of Service"
                                            }}</span>
                                        </v-btn>
                                    </template>
                                    {{ machine.status_id == "176" ? $t("lang.click_to_activate") : $t("lang.click_to_deactivate") }}
                                </bc-tooltip>
                                <v-chip v-else disabled round text-color="white" class="chip-padding-left-4 mr-auto fs-14" :color="machine.status_class">
                                    <span
                                        ><v-icon v-model="machine.status" class="mr-2">{{
                                            machine.status_id == "175" ? "check_circle" : "cancel"
                                        }}</v-icon></span
                                    >
                                    <span class="white--text">{{ machine.status_id == "175" ? "Operational" : "Out of Service" }}</span>
                                </v-chip>
                            </v-flex>
                            <v-flex xs4 pr-0 py-0>
                                <div class="ml-auto">
                                    <bc-tooltip perm="machines.update">
                                        <template slot="activator">
                                            <v-btn @mouseup.left="openMachineDialog()" icon>
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t("lang.modify_machine") }}
                                    </bc-tooltip>
                                </div>
                            </v-flex>
                            <v-flex xs12 py-0>
                                <bc-tooltip top :disabled="!hasPerm('machines.update')">
                                    <template slot="activator">
                                        <v-img
                                            :src="showErrorImg ? errorImg : machine.photo"
                                            height="150px"
                                            width="150px"
                                            :class="{ clickable: hasPerm('machines.update') }"
                                            class="rounded-circle mx-auto"
                                            @mouseup.left="hasPerm('machines.update') ? $refs.croppa.chooseFile() : ''"
                                            :key="updatePhoto"
                                            @error="showErrorImg = true"
                                        ></v-img>
                                    </template>
                                    {{ $t("lang.uploadImage") }}
                                </bc-tooltip>
                            </v-flex>
                            <v-flex py-1>
                                <p class="display-1 mb-0 text-xs-center">{{ machine.machine_name }}</p>
                                <pre class="display-0 mb-0 text-xs-center">{{ machine.production_line }}</pre>
                                <small class="display-0 mb-0 text-xs-center">{{ machine.option }}</small>
                            </v-flex>
                        </v-layout>
                        <v-divider class="my-0"></v-divider>
                        <!-- <bc-list prepend-icon="info" prepend-position="top">
                            <template>
                                <v-container pa-2>
                                    <v-layout row wrap>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.alias")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.company_short || "---" }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.shipping_number")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.shipping_number || "---" }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.correspondence_method")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{
                                            customer.correspondence_method ? $t(`lang.${customer.correspondence_method}`) : "---"
                                        }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.currency_code")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.currency_code || "---" }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.payment_terms")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.payment_terms_description || "---" }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.has_nda")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.has_nda == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.has_contract")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ customer.has_contract == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                        <v-flex xs8 mt-1>{{ `${$t("lang.ship_label_type")}:` }}</v-flex>
                                        <v-flex xs4 fw-bold mt-1>{{ ship_label_type_display }}</v-flex>
                                    </v-layout>
                                </v-container>
                            </template>
                        </bc-list> -->
                    </v-flex>
                    <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                    <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                        <div></div>
                    </v-flex>
                </v-layout>
            </v-container>
            <bc-dialog :value="machine_dialog">
                <v-card>
                    <v-form ref="form_machine">
                        <v-card-title>
                            <span class="headline">{{ machine.machine_id ? $t("lang.edit_machine") : $t("lang.add_machine") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeMachineDialog"
                                :dialog-status="machine_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-focus="machine_dialog"
                                            v-model="machine.line_id"
                                            :label="$t('lang.line_id')"
                                            :items="production_lines"
                                            item-value="line_id"
                                            item-text="production_line"
                                            :rules="ifValid('machines.line_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.machine_name"
                                            :label="`${$t('lang.machine_name')} *`"
                                            :counter="showCounter(machine.machine_name, 'machines.machine_name')"
                                            :rules="ifValid('machines.machine_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.short_code"
                                            :label="$t('lang.short_code')"
                                            :counter="showCounter(machine.short_code, 'machines.short_code')"
                                            :rules="ifValid('machines.short_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="machine.category_id"
                                            :label="$t('lang.category_id')"
                                            :counter="showCounter(machine.category_id, 'machines.category_id')"
                                            :rules="ifValid('machines.category_id')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="machine.machine_id" color="error" @mouseup.left="$refs.delete_machines.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeMachineDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveCurrentMachine()">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_machine"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_machine')"
                :message="$t('lang.delete_machine_confirm')"
                @onConfirm="deleteMachines()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_machine_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteMachineDetails()"
            ></delete-confirmation-dialog>
            <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            machine: {},
            file_name: "",
            dbGetMachine: _.debounce(this.getMachine, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            status_loader: false,
            updatePhoto: 0,
            errorImg: AppConfig.defaultProfileLogo,
            showErrorImg: false,
            machine_dialog: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchMachine", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.machines) {
                        this.machine = this.assignObj2(data.machines, this.rules_machines);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=machine_status&sort_by=2",
                            method: "get",
                            stateProperty: "machine_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "settings_machines", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchMachine", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.machines) {
                        next((vm) => {
                            vm.machine = vm.assignObj2(data.machines, vm.rules_machines);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=machine_status&sort_by=2",
                                method: "get",
                                stateProperty: "machine_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "settings_machines", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=machine_status&sort_by=2",
            method: "get",
            stateProperty: "machine_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_machines: (state) => state.machines.rules_machines,
            machine_status_options: (state) => state.settings.machine_status_options,
            machines: (state) => state.machines.machines,
            selectedMachine: (state) => state.machines.selectedMachine,
            app_languages_items: (state) => state.app_languages_items.app_languages_items,
            production_lines: (state) => state.production.production_lines,
        }),
    },
    methods: {
        ...mapActions(["fetchMachine", "saveMachine", "deleteMachine", "printMachine", "fetchAppLanguagesItems", "uploadMachinePhoto"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getMachine(pg_refresh = false) {
            this.startLoader();

            this.fetchMachine({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.machine) {
                    this.machine = this.assignObj2(data.machine, this.rules_machines);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printMachine({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.machine) {
                    if (this.dev_mode) {
                        this.file_name = data.machine.file_name;
                    } else {
                        this.$refs.print.printReport(data.machine.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveMachines() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formMachine")) {
                    let body = this.prepForm(this.machine, this.rules_machines);

                    this.saveMachine({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.machine) {
                            this.$router.push({ name: "machine", params: { id: data.machine.machine_id } });
                        } else {
                        }
                    });
                }
            });
        },
        saveCurrentMachine() {
            this.validationOn();
            if (this.validateForm("form_machine")) {
                let body = this.prepForm(this.machine, this.rules_machines);

                this.saveMachine({
                    body: body,
                }).then((data) => {
                    if (typeof data != "undefined" && data.machines) {
                        this.machine = this.assignObj2(data.machines, this.rules_machines);
                        this.status_loader = false;
                        this.machine_dialog = false;
                        this.validationOff();
                    }
                });
            }
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { machine_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveMachine({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.machines) {
                    this.machine = this.assignObj2(data.machines, this.rules_machines);
                    this.status_loader = false;
                }
            });
        },
        deleteMachines() {
            this.deleteMachine({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "machines" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchMachine({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.machines) {
                        this.machine = this.assignObj2(data.machines, this.rules_machines);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            this.getProductionLines();
        },
        closeMachineDialog() {
            this.machine_dialog = false;
            this.$refs.delete_machines.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        openMachineDialog() {
            this.machine_dialog = true;
        },
        getProductionLines() {
            this.startLoader();
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.production_line_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader();
                });
        },
        handleFileUpload(file) {
            this.toggleModalLoader(true);

            let body = { machine_id: `${this.$route.params.id}`, photo_file: file };

            this.uploadMachinePhoto({
                body: body,
            })
                .then((data) => {
                    if (typeof data != "undefined" && data.machines) {
                        this.machine = this.assignObj2(data.machines, this.rules_machines);
                        this.status_loader = false;
                        this.finishLoader();
                    }
                })
                .finally(() => {
                    this.toggleModalLoader(false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
